import GoldIcon1 from "@/app/assets/svg/gold-asset-1.svg";
import GoldIcon2 from "@/app/assets/svg/gold-asset-2.svg";
import GoldIcon3 from "@/app/assets/svg/gold-asset-3.svg";
import GoldIcon4 from "@/app/assets/svg/gold-asset-4.svg";
import GoldIcon5 from "@/app/assets/svg/gold-asset-5.svg";
import GoldIcon6 from "@/app/assets/svg/gold-asset-6.svg";

export const DigitalGoldFeatures = [
    {
        icon: GoldIcon1,
        title: "Highest purity",
        description: "Invest in 24K gold and experience unmatched purity",
    },
    {
        icon: GoldIcon2,
        title: "Sell anytime from home",
        description:
            "Sell anytime, without going anywhere and receive money direct in your account.",
    },
    {
        icon: GoldIcon3,
        title: "Multiple purchase option",
        description:
            "You can purchase digital gold 1-time or through SIP as per your investment goal.",
    },
    {
        icon: GoldIcon4,
        title: "Safety guaranteed",
        description: "Your gold is securely stored in bank-grade vaults at free of cost",
    },
    {
        icon: GoldIcon5,
        title: "Convert to physical gold",
        description:
            "You can convert your digital gold to physical gold anytime in the form of coins through our partners.",
    },
    {
        icon: GoldIcon6,
        title: "Buy as low as ₹10",
        description:
            "Digital does not require to invest a large sum of money. You can invest based on your budget.",
    },
];

export const DigitalSilverFeatures = [
    {
        icon: GoldIcon1,
        title: "Highest purity",
        description: "Invest in silver and experience unmatched purity",
    },
    {
        icon: GoldIcon2,
        title: "Sell anytime from home",
        description:
            "Sell anytime, without going anywhere and receive money direct in your account.",
    },
    {
        icon: GoldIcon3,
        title: "Multiple purchase option",
        description:
            "You can purchase digital silver 1-time or through SIP as per your investment goal.",
    },
    {
        icon: GoldIcon4,
        title: "Safety guaranteed",
        description: "Your silver is securely stored in bank-grade vaults at free of cost",
    },
    {
        icon: GoldIcon5,
        title: "Convert to physical silver",
        description:
            "You can convert your digital silver to physical silver anytime in the form of coins through our partners.",
    },
    {
        icon: GoldIcon6,
        title: "Buy as low as ₹10",
        description:
            "Digital does not require to invest a large sum of money. You can invest based on your budget.",
    },
];
